var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyInternationalOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 131,
    viewBox: "0 0 152 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 58,
    r: 52,
    fill: "#E4E7EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 109,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 41,
    r: 7,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 14,
    r: 4,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8_128813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 36.0629L80.536 34.1629L76.0006 36.0951V90.1898L117.796 72.6754V18.5566L118 18.4712L117.796 18.3809V18.29L117.692 18.3346L76.3298 0L34 18.0314L34.2004 18.1175L34 72.0166L76 90.1576L76 36.0629Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 36.0626V90.1573L34 72.0163L34.2004 18.1172L76 36.0626Z",
    fill: "url(#paint0_linear_8_128813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0007 36.0951V90.1898L117.796 72.6754V18.29L76.0007 36.0951Z",
    fill: "url(#paint1_linear_8_128813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 36.0629L118 18.4712L76.3298 0L34 18.0314L76 36.0629Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8325 11.2878L91.6723 29.4991L92.0524 42.7703L103.759 37.94L103.405 24.585L60.3271 6.81738L49.8325 11.2878Z",
    fill: "#E4E7EC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8_128813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 68,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9999 98.7996C71.9999 98.358 71.6423 97.9996 71.1999 97.9996H69.5999C68.7175 97.9996 67.9999 97.282 67.9999 96.3996V94.7996C67.9999 94.358 67.6423 93.9996 67.1999 93.9996C66.7575 93.9996 66.3999 94.358 66.3999 94.7996V96.3996C66.3999 98.1644 67.8351 99.5996 69.5999 99.5996H71.1999C71.6423 99.5996 71.9999 99.2412 71.9999 98.7996ZM85.5999 96.3996V94.7996C85.5999 94.358 85.2423 93.9996 84.7999 93.9996C84.3575 93.9996 83.9999 94.358 83.9999 94.7996V96.3996C83.9999 97.282 83.2823 97.9996 82.3999 97.9996H80.7999C80.3575 97.9996 79.9999 98.358 79.9999 98.7996C79.9999 99.2412 80.3575 99.5996 80.7999 99.5996H82.3999C84.1647 99.5996 85.5999 98.1644 85.5999 96.3996ZM85.5999 88.3996V86.7996C85.5999 85.0348 84.1647 83.5996 82.3999 83.5996H80.7999C80.3575 83.5996 79.9999 83.958 79.9999 84.3996C79.9999 84.8412 80.3575 85.1996 80.7999 85.1996H82.3999C83.2823 85.1996 83.9999 85.9172 83.9999 86.7996V88.3996C83.9999 88.8412 84.3575 89.1996 84.7999 89.1996C85.2423 89.1996 85.5999 88.8412 85.5999 88.3996ZM67.9999 88.3996V86.7996C67.9999 85.9172 68.7175 85.1996 69.5999 85.1996H71.1999C71.6423 85.1996 71.9999 84.8412 71.9999 84.3996C71.9999 83.958 71.6423 83.5996 71.1999 83.5996H69.5999C67.8351 83.5996 66.3999 85.0348 66.3999 86.7996V88.3996C66.3999 88.8412 66.7575 89.1996 67.1999 89.1996C67.6423 89.1996 67.9999 88.8412 67.9999 88.3996ZM77.5999 96.3996C77.3791 96.3996 77.1999 96.2204 77.1999 95.9996V87.1996C77.1999 86.9788 77.3791 86.7996 77.5999 86.7996C77.8207 86.7996 77.9999 86.9788 77.9999 87.1996V95.9996C77.9999 96.2204 77.8207 96.3996 77.5999 96.3996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1999 95.9996C77.1999 96.2204 77.3791 96.3996 77.5999 96.3996C77.8207 96.3996 77.9999 96.2204 77.9999 95.9996V87.1996C77.9999 86.9788 77.8207 86.7996 77.5999 86.7996C77.3791 86.7996 77.1999 86.9788 77.1999 87.1996V95.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7999 95.9996C74.7999 96.2204 74.9791 96.3996 75.1999 96.3996C75.4207 96.3996 75.5999 96.2204 75.5999 95.9996V87.1996C75.5999 86.9788 75.4207 86.7996 75.1999 86.7996C74.9791 86.7996 74.7999 86.9788 74.7999 87.1996V95.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3999 95.9996C72.3999 96.2204 72.5791 96.3996 72.7999 96.3996C73.0207 96.3996 73.1999 96.2204 73.1999 95.9996V87.1996C73.1999 86.9788 73.0207 86.7996 72.7999 86.7996C72.5791 86.7996 72.3999 86.9788 72.3999 87.1996V95.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 95.9996C69.9999 96.2204 70.1791 96.3996 70.3999 96.3996C70.6207 96.3996 70.7999 96.2204 70.7999 95.9996V87.1996C70.7999 86.9788 70.6207 86.7996 70.3999 86.7996C70.1791 86.7996 69.9999 86.9788 69.9999 87.1996V95.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5999 95.9996C79.5999 96.2204 79.7791 96.3996 79.9999 96.3996C80.2207 96.3996 80.3999 96.2204 80.3999 95.9996V87.1996C80.3999 86.9788 80.2207 86.7996 79.9999 86.7996C79.7791 86.7996 79.5999 86.9788 79.5999 87.1996V95.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9999 95.9996C81.9999 96.2204 82.1791 96.3996 82.3999 96.3996C82.6207 96.3996 82.7999 96.2204 82.7999 95.9996V87.1996C82.7999 86.9788 82.6207 86.7996 82.3999 86.7996C82.1791 86.7996 81.9999 86.9788 81.9999 87.1996V95.9996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8_128813",
    x: 14,
    y: 0,
    width: 124,
    height: 130.189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_128813"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_128813"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_128813"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_128813",
    result: "effect2_dropShadow_8_128813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_128813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8_128813",
    x: 44,
    y: 60,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8_128813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8_128813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_128813",
    x1: 34,
    y1: 72.2882,
    x2: 50.587,
    y2: 27.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_128813",
    x1: 76.0001,
    y1: 37.1539,
    x2: 123.359,
    y2: 46.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInternationalOrders);
export default __webpack_public_path__ + "f020dbf9a185a1461477423c85ad2493.svg";
export { ForwardRef as ReactComponent };